<!-- footer -->
<template>
  <div class="footer">
    <div class="footer1">
      <div class="footer1-1">
        <h3>
          <img src="../assets/image/rexianicon.png" alt/> 合作热线
        </h3>
        <h2>15617953373</h2>
        <p>全国服务时间：</p>
        <p>周一至周日 9:00-18:00</p>
      </div>
      <div class="footer1-2">
        <div class="footer1-21">
          <h4>产品</h4>
          <!-- <router-link to="/products"><p @click="lista12(1)">零售版</p></router-link>
          <router-link to="/products"><p @click="lista12(2)">分销版</p></router-link>-->
          <router-link to="/product">
            <p>零售版</p>
          </router-link>
          <router-link to="/product/products2">
            <p>分销版</p>
          </router-link>
        </div>
        <div class="footer1-22">
          <div class="footer1-21">
            <h4>服务</h4>
            <router-link to="/service">
              <p>服务与实施</p>
            </router-link>
            <router-link to="/service">
              <p>中关村商学院</p>
            </router-link>
            <router-link to="/service">
              <p>实施案例</p>
            </router-link>
          </div>
        </div>
        <div class="footer1-23">
          <div class="footer1-21">
            <h4>价格</h4>
            <router-link to="/price">
              <p>价格列表</p>
            </router-link>
          </div>
        </div>
        <div class="footer1-24">
          <div class="footer1-21">
            <h4>关于我们</h4>
            <router-link to="/about">
              <p>公司简介</p>
            </router-link>
            <router-link to="/about">
              <p>联系我们</p>
            </router-link>
            <p></p>
          </div>
        </div>
      </div>
      <div class="footer1-3">
        <div class="footer1-31">
          <p>订阅号</p>
          <img src="../assets/image/dingyuehao@2x.png" alt/>
          <br/>
          <!-- <br /> -->
          <p>ZOL智选云商</p>
        </div>
        <div class="footer1-3x"></div>
        <div class="footer1-32">
          <p>服务号</p>
          <img src="../assets/image/fuwuhao1@2x.png" alt/>
          <br/>
          <!-- <br /> -->
          <p>ZOL智选云商</p>
        </div>
        <div class="footer1-33">
          <p>服务号</p>
          <img src="../assets/image/fuwuhao2@2x.png" alt/>
          <br/>
          <!-- <br /> -->
          <p>科技智能手机终端</p>
        </div>
      </div>
    </div>
    <div class="xian"></div>
    <div class="di1">
      <div class="di11">
        <p>
          <span>Copyright © 2017-2023 智选云商 </span>
          <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2023010059号-1 </a>
          <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010402002964" target="_blank">豫公网安备：41010402002964号</a>
          <a id="xyt-box" href="https://xyt.xcc.cn/getpcInfo?sn=1783096803814510592&language=CN&certType=8&url=*.yserp.cc" target="_blank"
             style="position: relative;display: inline-block;height: 38px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/web/1783096803814510592=*.yserp.cc.svg" width="103" height="38"
                   type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
          </a>
        </p>
      </div>
      <div class="di12">
        <p></p>
      </div>
      <div class="di13" style="display: flex">
        <p>公司地址：河南省郑州市紫荆山路57号裕鸿国际C座1606室</p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      lista1: 1,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // lista12(v) {
    //   //$emit()
    //   //第一个参数自定义的事件
    //   //第二个参数传递的数据，如果数据有多个，可以写成数组或对象的形式
    //   // console.log(v)
    //   this.lista1 = v
    //   this.$emit("myevent", this.lista1);
    // }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.footer {
  width: 100%;
  //height: 300px;
  background-color: #272b2e;

  .footer1 {
    width: 1200px;
    height: 200px;
    margin: 0px auto;
    // border: 1px solid red;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;

    .footer1-1 {
      width: 190px;
      // border: 1px solid red;
      height: 160px;

      h3 {
        color: #ffffff;
        font-size: 18px;
        margin: 0;

        img {
          padding-bottom: 15px;
        }
      }

      h2 {
        color: #ffffff;
        margin: 0;
        font-size: 30px;
        margin-bottom: 20px;
        margin-bottom: 5px;
        margin-top: -5px;
      }

      p {
        color: #999999;
        font-size: 14px;
        margin: 5px 0px;
      }
    }

    .footer1-2 {
      width: 500px;
      // border: 1px solid red;
      height: 160px;
      display: flex;
      justify-content: space-between;

      .footer1-21 {
        width: 100px;
        height: 160px;

        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          color: #999999;
        }

        a {
          color: #999999;
          text-decoration: none;
        }
      }

      .footer1-22 {
        width: 85px;
        height: 160px;

        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          color: #999999;
        }
      }

      .footer1-23 {
        width: 86px;
        height: 160px;

        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          color: #999999;
        }
      }

      .footer1-24 {
        width: 57px;
        height: 160px;

        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          color: #999999;
        }
      }

      a:hover p {
        color: white;
        z-index: 99999;
      }
    }

    .footer1-3 {
      width: 350px;
      height: 160px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;

      .footer1-3x {
        width: 2px;
        height: 128px;
        margin-top: 18px;
        margin-right: 5px;
        // padding: 10px 0px;
        // padding-right: 20px;
        border-right: 1px solid #4e5357;
      }

      .footer1-31 {
        width: 100px;
        height: 160px;

        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }

        img {
          width: 95px;
          height: 95px;
        }
      }

      .footer1-32 {
        width: 100px;
        height: 160px;

        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }

        img {
          width: 95px;
          height: 95px;
        }
      }

      .footer1-33 {
        width: 120px;
        height: 160px;
        //  border: 1px solid red;
        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }

        img {
          margin-left: 10px;
          width: 95px;
          height: 95px;
        }
      }
    }
  }

  .xian {
    width: 1200px;
    height: 0px;
    margin: 0px auto;
    margin-top: 40px;
    border-top: 2px solid #404345;
  }

  .di1 {
    width: 1200px;
    margin: 0px auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    p {
      font-size: 12px;
      color: #999999;
      display: flex;
      align-items: center;

      #xyt-box {
        margin-left: 10px;
      }

      a {
        color: #999999;
      }
    }
  }
}
</style>
